import React from 'react';
import {Stack, Skeleton, Divider} from '@mui/material';
import _ from 'lodash';

export const CopilotSkeleton = () => {
  return (
    <Stack direction="column">
      <Divider color="#DDE0DE" />
      <Stack direction="column" spacing={2} py={2}>
        {_.times(6, (index) => (
          <Stack direction="column" spacing={0.25} key={index}>
            <Skeleton variant="rectangle" height="1.25rem" />
            <Skeleton variant="rectangle" height="1.25rem" width="75%" />
          </Stack>
        ))}
      </Stack>
      <Divider color="#DDE0DE" />
    </Stack>
  );
};
